import { useTIFFormData } from "../../../../hooks";
import { corneaTissueTypes, ProcedureTypes, TissueTypes } from "../../../../models";
import {
    TIFPostProcedureGradingCairs,
    TIFPostProcedureGradingCornea,
    TIFPostProcedureGradingOther,
    TissueInformationFormProps,
} from ".";

export function TIFPostProcedureGrading({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { latestProcedure, tissue } = useTIFFormData({ tissueId });
    const tissueType: TissueTypes = tissue?.tissueType?.name as TissueTypes;
    const isCairs = latestProcedure?.procedureType?.name === ProcedureTypes.CAIRS;
    const isCornea = [...corneaTissueTypes, TissueTypes.WholeGlobe].includes(tissueType);

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    if (isCairs) {
        return <TIFPostProcedureGradingCairs tissueId={tissueId} />;
    }

    if (isCornea) {
        return <TIFPostProcedureGradingCornea tissueId={tissueId} />;
    }

    return <TIFPostProcedureGradingOther tissueId={tissueId} />;
}
